/**
 * Whether dev bypass auth is enabled (local frontend+backend testing without SSO).
 * Do not use in deployed environments.
 */
export const isDevBypassAuthEnabled = (): boolean =>
  process.env.REACT_APP_DEV_BYPASS_AUTH === 'true';

/** Mock user id used when dev bypass is enabled (must match local backend expectation). */
export const DEV_BYPASS_USER_ID = 'local-user-id';

/**
 * Handles the authentication callback from Cognito
 * Extracts the authorization code from the URL and exchanges it for tokens
 */
export const handleAuthCallback = () => {
  // Parse the URL for the authorization code
  const urlParams = new URLSearchParams(window.location.search);
  const code = urlParams.get('code');
  
  if (code) {
    // In a real implementation with the full AWS Amplify library,
    // this would be handled automatically by Amplify's Auth module
    // For now, we'll simulate a successful login
    const mockUser = {
      username: 'user@example.com',
      attributes: {
        email: 'user@example.com',
        name: 'Test User'
      }
    };
    
    // Store the user in localStorage
    localStorage.setItem('amplify_user', JSON.stringify(mockUser));
    
    // Dispatch a custom event to notify the auth context
    const event = new CustomEvent('amplify_auth_event', {
      detail: { event: 'signIn' }
    });
    window.dispatchEvent(event);
    
    // Remove the code from the URL to prevent multiple login attempts
    window.history.replaceState({}, document.title, window.location.pathname);
    
    return true;
  }
  
  return false;
};
